<template>
  <div>
    <div class="gj_top_search" v-if="Options.searchMode">
      <input type="button" style="margin-right: 0;" class="btn_s_gj" @click="search($event)" /><!-- gap eliminated
      --><span class="put_gjef">
        <input type="text" @keyup.enter="search($event)" @input="search($event)" class="put_gj" v-model="searchText" style="border: 0; margin: 0;" />
        <span @click.stop="searchText = ''" style="position: absolute; top: 0; right: 12px; cursor: pointer; color: #606266;">x</span>
    </span>
    </div>
    <div :style="ScrollStyle">
      <div v-if="nodeList && nodeList.length > 0" :style="BoxStyle" class="gj_list" v-for="item in nodeList" :key="item.id">
        <item :model="item" :options="Options" :search-text="searchText" @node-clicked="nodeClicked" @width-resize="getWidth"></item>
      </div>
    </div>
    <div v-if="nodeList.length == 0">
      <img src="@/assets/images/none_data.jpg" alt="">
    </div>
  </div>
</template>
<script>
  import item from './item.vue'
  import utils from './utils.js'
  export default {
    name: 'treeview',
    components: { item },
    mounted () {
      this.nodeList = JSON.parse(JSON.stringify(this.model)) // 初始化, 避免循环引用
      // this.nodeList = utils.deepCopy([], this.model)
    },
    watch: {
      model (val) { // 外部异步获取到的数据一旦有变，需要手动更新内部数据
        this.nodeList = JSON.parse(JSON.stringify(val))
      }
    },
    data () {
      return {
        Options: (this.options) ? this.options : {},
        searchText: '',
        scrollWidth: 240,
        nodeList: []
      }
    },
    computed: {
      BoxStyle () {
        if (this.options.hasScroll) {
          return {width: `${this.scrollWidth}px`} // 可以动态计算
        }
        return {}
      },
      ScrollStyle () {
        if (this.options.hasScroll) {
          if (this.options.boxStyle && this.options.boxStyle.height) {
            return {overflow: 'scroll', height: this.options.boxStyle.height}
          } else {
            return {overflow: 'scroll', height: '435px'}
          }
        }
        return {}
      }
    },
    methods: {
      nodeClicked (node) {
        this.$emit('node-clicked', node)
      },
      getWidth (w) {
        this.scrollWidth = w
      },
      // 对子节点进行搜索。
      searchEach (node, value) { // “剪叶子”算法
        let depth = this.getTreeDepth(node);
        let self = this;
        for (let i = 0; i < depth - 1; i++) {
          // 记录【删除不匹配搜索内容的叶子节点】操作的次数。
          // 如果这个变量记录的操作次数为0，表示树形结构中，所有的
          // 叶子节点(不包含只有根节点的情况)都匹配搜索内容。那么就没有必要再
          // 在循环体里面遍历树了.
          let spliceCounter = 0;

          // 遍历树形结构
          this.traverseTree(node, n => {
            if (self.isHasChildren(n)) {
              let children = n.children;
              let length = children.length;

              // 找到不匹配搜索内容的叶子节点并删除。为了避免要删除的元素在数组中的索引改变，从后向前循环,
              // 找到匹配的元素就删除。
              for (let j = length - 1; j >= 0; j--) {
                let e3 = children[j];
                if (!self.isHasChildren(e3) && e3.name.indexOf(value) <= -1) {
                  children.splice(j, 1);
                  spliceCounter++;
                }
              } // end for (let j = length - 1; j >= 0; j--)
            }
          }); // end this.traverseTree(node, n=>{

          // 所有的叶子节点都匹配搜索内容，没必要再执行循环体了。
          if (spliceCounter == 0) {
            break;
          }
        }
      },
      // 搜索框回车事件响应
      search (e) {
        let self = this;
        this.nodeList = JSON.parse(JSON.stringify(this.model));
        // this.nodeList = utils.deepCopy([], this.model) // 把树形结构还原成搜索以前的。
        if (this.searchText == '') {
          this.searchText = "";
          return;
        }
        if (this.nodeList && this.nodeList.length > 0) {
          this.nodeList.forEach((n, i, a) => {
            self.searchEach(n, this.searchText);
          });

          // 没有叶子节点的根节点也要清理掉
          let length = this.nodeList.length;
          for (let i = length - 1; i >= 0; i--) {
            let e2 = this.nodeList[i];
            if (!this.isHasChildren(e2) && e2.name.indexOf(this.searchText) <= -1) {
              this.nodeList.splice(i, 1);
            }
          }
        }
        console.log(this.nodeList)
      },
      // 判断树形结构中的一个节点是否具有孩子节点
      isHasChildren (node) {
        let flag = false;
        if (node.children && node.children.length > 0) {
          flag = true;
        }
        return flag;
      },

      // 通过传入根节点获得树的深度，是 calDepth 的调用者。
      getTreeDepth (node) {
        if (node == undefined || node == null) {
          return 0;
        }
        // 返回结果
        let r = 0;
        // 树中当前层节点的集合。
        let currentLevelNodes = [node];
        // 判断当前层是否有节点
        while (currentLevelNodes.length > 0) {
          // 当前层有节点，深度可以加一。
          r++;
          // 下一层节点的集合。
          let nextLevelNodes = [];
          // 找到树中所有的下一层节点，并把这些节点放到 nextLevelNodes 中。
          for (let i = 0; i < currentLevelNodes.length; i++) {
            let e = currentLevelNodes[i];
            if (this.isHasChildren(e)) {
              nextLevelNodes = nextLevelNodes.concat(e.children);
            }
          }
          // 令当前层节点集合的引用指向下一层节点的集合。
          currentLevelNodes = nextLevelNodes;
        }
        return r;
      },

      // 非递归遍历树
      // 作者：张超
      traverseTree (node, callback) {
        if (!node) {
          return;
        }
        var stack = [];
        stack.push(node);
        var tmpNode;
        while (stack.length > 0) {
          tmpNode = stack.pop();
          callback(tmpNode);
          if (tmpNode.children && tmpNode.children.length > 0) {
            for (let i = tmpNode.children.length - 1; i >= 0; i--) {
              stack.push(tmpNode.children[i]);
            }
          }
        }
      }
    },
    props: ['model', 'options']
  }
</script>
<style scoped>
  @import './index.css';
</style>



// WEBPACK FOOTER //
// src/components/common/treeview/index.vue